import React from 'react';
import SVGIcon from 'components/shared/SVGIcon';
import LoadingIndicator from './LoadingIndicator/LoadingIndicator';
import './LoadingSplashScreen.scss';
const LoadingSplashScreen = () => {
    return (React.createElement("div", { className: "center-loading-screen fade-in" },
        React.createElement(SVGIcon, { iconName: "icon-loading-page", size: 160 }),
        React.createElement(LoadingIndicator, { customClass: "mt-[24px]" })));
};
export default LoadingSplashScreen;
